import { render, staticRenderFns } from "./ArticleSearchResultItem.vue?vue&type=template&id=d3c2e0e6&"
import script from "./ArticleSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./ArticleSearchResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports